import type { SVGProps } from "react";
export interface WifiShieldIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WifiShieldIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WifiShieldIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.896 14.682c2.81-2.981 7.397-2.981 10.208 0a1.126 1.126 0 0 1-1.636 1.544c-1.923-2.04-5.012-2.04-6.935 0a1.126 1.126 0 0 1-1.637-1.544m4.438-6.501a1.125 1.125 0 0 1 .14 2.246c-2.1.13-4.175 1.046-5.799 2.768l-.082.08a1.125 1.125 0 0 1-1.554-1.622l.385-.39c1.96-1.892 4.41-2.926 6.91-3.082m-.417-4.266a1.126 1.126 0 0 1 .167 2.244c-3 .225-5.952 1.553-8.265 4.007a1.126 1.126 0 0 1-1.638-1.544c2.7-2.864 6.178-4.44 9.736-4.707m1.3 12.971a2.125 2.125 0 1 1-2.332 2.332L9.875 19l.01-.217a2.126 2.126 0 0 1 2.116-1.908zm8.658-11.5L18.5 4.196l-2.374 1.188v1.738l.014.168c.07.407.39.906.977 1.45.472.436 1 .794 1.383 1.027a9 9 0 0 0 1.383-1.027c.672-.621.992-1.185.992-1.618V5.385Zm2.25 1.737-.01.262c-.106 1.297-.976 2.335-1.704 3.009a11.2 11.2 0 0 1-1.75 1.3l-.395.232c-.418.232-.912.26-1.349.086l-.183-.086c-.417-.232-1.327-.774-2.146-1.532-.728-.674-1.597-1.712-1.702-3.01l-.01-.261V4.999c0-.616.347-1.178.898-1.454l3-1.5.174-.074a1.63 1.63 0 0 1 1.104 0l.175.074 3 1.5.196.116c.436.3.702.799.702 1.338z"
      />
    </svg>
  );
}
